import Vue from 'vue'
import Vuex from 'vuex'
import login from './modules/login'
import rent from './modules/rentroom'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    login,
    rent
  },
  strict: true
})
